import React from "react";
import { PropTypes } from "prop-types";
import { MrbFieldLayout } from "../layout/content/form";
import { mergeOrOverrideCss } from "../../common/utils";
import { MrbNumericInput } from "./";
import { isNil } from "lodash";
import { observer } from "mobx-react";

function MrbFieldNumericInput({
    field,
    t = (i) => i,
    showLabel = true,
    disabled,
    labelRender = null,
    validationRender = null,
    classNameExtend,
    classNameOverride,
    fieldClassNameExtend,
    fieldClassNameOverride,
    ...restOfProps
}) {
    const { placeholder, ...otherProps } = field.bind();

    if (otherProps.value && typeof otherProps.value === "string")
        otherProps.value = otherProps.value.replace(/\s+/g, " ");
    if (otherProps.value == null) otherProps.value = "";

    return (
        <MrbFieldLayout
            field={field}
            t={t}
            labelRender={labelRender}
            validationRender={validationRender}
            showLabel={showLabel}
            classNameExtend={fieldClassNameExtend}
            classNameOverride={fieldClassNameOverride}
        >
            <MrbNumericInput
                className={mergeOrOverrideCss(
                    "c-input c-input--outline c-input--numeric c-input--numeric--sml",
                    classNameOverride,
                    classNameExtend
                )}
                {...otherProps}
                {...restOfProps}
                disabled={isNil(disabled) ? otherProps.disabled : disabled}
                placeholder={t(placeholder)}
            />
        </MrbFieldLayout>
    );
}

MrbFieldNumericInput.propTypes = {
    field: PropTypes.object.isRequired,
    showLabel: PropTypes.bool,
    t: PropTypes.func,
    labelRender: PropTypes.func,
    validationRender: PropTypes.func,
    classNameExtend: PropTypes.string,
    classNameOverride: PropTypes.string,
    fieldClassNameExtend: PropTypes.string,
    fieldClassNameOverride: PropTypes.string,
};

export default observer(MrbFieldNumericInput);
